// InventoryManager.js

class InventoryManager {
    useItem(gameState, action) {
      const { character } = gameState;
      const { itemId } = action;
  
      const itemIndex = character.items.findIndex(item => item.item.id === itemId);
      if (itemIndex === -1) {
        throw new Error(`Item with id ${itemId} not found in character's inventory`);
      }
  
      const item = character.items[itemIndex].item;
      let result = {
        success: true,
        message: `Used ${item.name}`,
        updatedCharacter: { ...character }
      };
  
      switch (item.type) {
        case 'POTION':
          result = this.usePotion(result, item);
          break;
        case 'SCROLL':
          result = this.useScroll(result, item);
          break;
        case 'WEAPON':
        case 'ARMOR':
          result = this.equipItem(result, item, itemIndex);
          break;
        default:
          result.message = `Used ${item.name}, but it had no effect`;
      }
  
      // Reduce item quantity or remove if it's the last one
      if (character.items[itemIndex].quantity > 1) {
        result.updatedCharacter.items[itemIndex].quantity -= 1;
      } else {
        result.updatedCharacter.items.splice(itemIndex, 1);
      }
  
      return result;
    }
  
    usePotion(result, item) {
      // Simplified potion effect, you might want to expand this
      const healAmount = 10;
      result.updatedCharacter.currentHealth = Math.min(
        result.updatedCharacter.currentHealth + healAmount,
        result.updatedCharacter.maxHealth
      );
      result.message = `Used ${item.name} and healed for ${healAmount} HP`;
      return result;
    }
  
    useScroll(result, item) {
      // Simplified scroll effect, you might want to expand this
      result.message = `Used ${item.name} scroll. A magical effect occurs!`;
      // You could add more complex magical effects here
      return result;
    }
  
    equipItem(result, item, itemIndex) {
      const { updatedCharacter } = result;
      const currentlyEquipped = updatedCharacter.items.find(
        i => i.item.type === item.type && i.isEquipped
      );
  
      if (currentlyEquipped) {
        currentlyEquipped.isEquipped = false;
      }
  
      updatedCharacter.items[itemIndex].isEquipped = true;
  
      // Update character stats based on equipped item
      if (item.type === 'WEAPON') {
        // Update attack bonus, damage, etc.
      } else if (item.type === 'ARMOR') {
        // Update armor class
        updatedCharacter.armorClass += item.armorBonus || 0;
      }
  
      result.message = `Equipped ${item.name}`;
      return result;
    }
  
    addItem(character, item, quantity = 1) {
      const existingItem = character.items.find(i => i.item.id === item.id);
      if (existingItem) {
        existingItem.quantity += quantity;
      } else {
        character.items.push({ item, quantity, isEquipped: false });
      }
      return character;
    }
  
    removeItem(character, itemId, quantity = 1) {
      const itemIndex = character.items.findIndex(i => i.item.id === itemId);
      if (itemIndex === -1) {
        throw new Error(`Item with id ${itemId} not found in character's inventory`);
      }
  
      if (character.items[itemIndex].quantity > quantity) {
        character.items[itemIndex].quantity -= quantity;
      } else {
        character.items.splice(itemIndex, 1);
      }
      return character;
    }
  }
  
  export default InventoryManager;